import client from '@common/utils/rest';

export const getFilters = () => {
  return client({
    path: 'api/filters/data',
    method: 'GET',
  }).then((response) => {
    return response.entity;
  });
};